export const KEYMAP = {
    feedback_type: "feedback_type",
    start_feedback: "feedback_pool",
    material_id: "material_id",
};
